"use client";
import React, { useEffect, useRef, useState } from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

type Props = {
  description?: string;
};

const Description = (props: Props) => {
  const t = useTranslations();
  const [seeMore, setSeeMore] = useState(false);
  const [isOverflowed, setIsOverflowed] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    if (textRef.current && !seeMore) {
      const { scrollHeight, clientHeight } = textRef.current;
      setIsOverflowed(scrollHeight > clientHeight);
    }
  }, [props.description, seeMore]);

  return (
    <Section>
      <SectionHeader>{t("description.header")}</SectionHeader>
      <p
        ref={textRef}
        className={cn(
          "text-gray-dark min-h-[72px] whitespace-pre-line break-words transition-all duration-300",
          { "line-clamp-3": !seeMore }
        )}
      >
        {props.description}
      </p>
      {isOverflowed && (
        <button
          onClick={() => setSeeMore((prev) => !prev)}
          className="text-primary mt-2"
        >
          {seeMore ? t("description.seeLess") : t("description.seeMore")}
        </button>
      )}{" "}
    </Section>
  );
};

export default Description;
